export default {
  grouping: {
    groupBy: "Gruppieren nach",
    assetClass: "Anlageklasse",
    currency: "Währung",
    sector: "Sektor",
    region: "Region",
    strategy: "Strategie",
    uncategorized: "Nicht kategorisiert",
  },
  pages: {
    avg: "Durchschnitt",
    max: "Max",
    min: "Min",
    footer: {
      page: "Seite",
    },
    strategyReport: {
      title: "Anlagevorschlag",
      strategyName: (ctx) =>
        `Strategiename: ${ctx.named("portfolioName")} (${ctx.named("currency")})`,
      forRecipient: (ctx) => `Für: ${ctx.named("recipient")}`,
      preparedBy: (ctx) => `Erstellt von: ${ctx.named("author")}`,
      period: (ctx) => `Zeitraum: ${ctx.named("periodStart")} - ${ctx.named("periodEnd")}`,
    },
    tableOfContents: {
      title: "Inhaltsverzeichnis",
    },
    portfolioComposition: {
      title: "Portfoliozusammensetzung",
      currencyAlloc: "Währungsallokation",
      assetClassAlloc: "Anlageklassenallokation",
      sectorAlloc: "Sektorenallokation",
      regionAlloc: "Regionenallokation",
      composition: "Zusammensetzung",
    },
    performanceAnalysis: {
      title: "Performanceanalyse",
      investGrowth: "Anlagewachstum",
      keyPerfStats: {
        title: "Wichtige Leistungskennzahlen",
      },
      histYearyRets: "Historische jährliche Renditen",
      histMonthRets: "Historische monatliche Renditen",
    },
    riskAnalysis: {
      title: "Risikoanalyse",
      drawdownAnalysis: "Drawdown-Analyse",
      drawdownTable: {
        title: "Drawdown-Tabelle",
        drawdownRank: "Drawdown-Rang",
        startDate: "Startdatum",
        troughDate: "Tiefpunkt",
        recoveryDate: "Erholungsdatum",
      },
    },
    portfolioHoldings: {
      title: "Portfoliobestände",
      topHoldings: {
        title: "Wichtigste Positionen",
        name: "Name",
        isin: "ISIN",
        currency: "Währung",
        assetClass: "Anlageklasse",
        sector: "Sektor",
        region: "Region",
        weight: "Gewicht",
      },
    },
  },
  productPicker: {
    add: "Hinzufügen",
    searchPlaceholder: "Nach einem Produkt suchen...",
  },
  report: {
    backToInputs: "Zurück zu den Eingaben",
    downloadReport: "Bericht herunterladen",
    taskFailed: (ctx) => `Aufgabe ${ctx.named("taskName")} fehlgeschlagen: ${ctx.named("reason")}`,
  },
  reportInputs: {
    generateReport: "Bericht erstellen",
    fields: {
      general: {
        title: "Allgemein",
        portfolioName: "Portfolioname",
        currency: "Währung",
        author: "Autor",
        recipient: "Empfänger",
        totalCapital: (ctx) => `Gesamtkapital (${ctx.named("currency")})`,
        totalCapitalTooltip:
          "Wird verwendet, um den investierten Betrag jeder Position in der Tabelle der wichtigsten Bestände anzuzeigen, unter Annahme dieses Kapitals am Periodenende. Leer lassen, um diese Spalte auszublenden.",
      },
      composition: {
        title: "Zusammensetzung",
        product: "Produkt",
        availableFrom: "Verfügbar ab",
        availableUntil: "Verfügbar bis",
        period: "Zeitraum",
        fullPeriod: "Gesamter Zeitraum",
        weight: "Gewicht (%)",
        addProduct: "Produkt hinzufügen",
        total: "Gesamt",
        selectOneProduct:
          "Wählen Sie mindestens ein Produkt in der Zusammensetzung, um einen Zeitraum auswählen zu können.",
        noOverlappingPricePeriod:
          "Die ausgewählten Produkte haben keine überlappende Preishistorie, daher kann kein Berichtszeitraum ausgewählt werden.",
      },
      miscellaneous: {
        title: "Sonstiges",
        numMonthlyReturns: "Anzahl Jahre für historische monatliche Renditen",
        numTopHoldings: "Anzahl Positionen für die wichtigsten Bestände",
        numTopHoldingsTooltip: "Leer lassen, um alle Bestände zu erhalten.",
      },
    },
  },
  weightOptimization: {
    portfoliosWeightsAllocation: "Gewichtsallokation der Portfolios",
    addProduct: "Produkt hinzufügen",
    addPortfolio: "Portfolio hinzufügen",
    total: "Gesamt",
    chartsAndTables: {
      buttonText: "Diagramme und Tabellen erstellen",
      dataLoadError:
        "Beim Laden der Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie Alquant AG, falls das Problem bestehen bleibt.",
      drawdowns: "Drawdowns",
      performance: "Performance",
      period: "Zeitraum",
      periodSelectionCondition:
        "Stellen Sie sicher, dass jede Komponente mit einem Gewicht ungleich null in einem Portfolio ein ausgewähltes Produkt hat.",
      returnToRiskSpace: "Zurück zum Risikoraum",
      selectedPortfolios: "Ausgewählte Portfolios",
      statistics: "Statistiken",
      year: "Jahr",
      yearlyReturns: "Jährliche Renditen",
    },
    actionTooltip: {
      restoreDefaultPortfolio: (ctx) =>
        `Zur Standardallokation für '${ctx.named("portfolioName")}' zurückkehren.`,
      optimizeWeight: (ctx) =>
        `Gewichte für '${ctx.named("portfolioName")}' basierend auf Einschränkungen und Zielen optimieren.`,
      cantOptimizeWeight:
        "Die Optimierung erfordert ein ausgewähltes Produkt für jede Zeile sowie mindestens eine Position.",
      usePortfolioToGenerateReport: (ctx) =>
        `Einen Bericht mit dem Portfolio '${ctx.named("portfolioName")}' erstellen.`,
      cantGenerateReport:
        "Die Berichterstellung erfordert ein ausgewähltes Produkt für jede Zeile sowie eine Gesamtallokation von genau 100 %.",
      removePortfolio: (ctx) => `'${ctx.named("portfolioName")}' aus dem Vergleich entfernen.`,
      cantRemovePortfolio: "Mindestens ein Portfolio muss im Vergleich bleiben.",
    },
    optimizationDialog: {
      title: "Optimierungseinstellungen",
      objective: "Ziel",
      period: "Optimierungszeitraum",
      bounds: "Allokationsgrenzen",
      addBound: "Grenze hinzufügen",
      singlePosition: "Einzelposition",
      type: "Typ",
      target: "Ziel",
      min: "Min",
      max: "Max",
      buttonText: "Optimierung ausführen",
      optimization: {
        maxRetWithTargetMaxVol: {
          name: "Rendite maximieren (Ziel-Jahresvolatilität)",
          targetTitle: "Maximale Jahresvolatilität",
        },
        maxRetWithTargetPainIndex: {
          name: "Rendite maximieren (Ziel-Pain-Index)",
          targetTitle: "Maximaler Pain-Index",
        },
        maxRetWithTargetMaxDrawdown: {
          name: "Rendite maximieren (Ziel-Drawdown)",
          targetTitle: "Maximaler Drawdown",
        },
        minVolWithTargetMinRet: {
          name: "Volatilität minimieren (Zielrendite)",
          targetTitle: "Mindestjahresrendite",
        },
        minDrawdownWithTargetMinRet: {
          name: "Maximalen Drawdown minimieren (Zielrendite)",
          targetTitle: "Mindestjahresrendite",
        },
        maxSharpe: {
          name: "Sharpe-Ratio maximieren",
        },
        maxSortino: {
          name: "Sortino-Ratio maximieren",
        },
      },
    },
    failedOptimizationDialog: {
      title: "Optimierung fehlgeschlagen",
      text: "Keine Lösung gefunden. Die Einschränkungen (Zielwerte und Allokationsgrenzen) könnten zu restriktiv sein.",
    },
  },
};
